import FJFileHandleUtil from '../util/FJFileHandleUtil';
import FJNetworkStore from './FJNetworkStore';
import FJUtil from '../util/FJUtil.js';
import FJTextToSpeechUtil from '../util/FJTextToSpeechUtil.js';
import FJStringUtil from '../util/FJStringUtil.js';

let pid = null;
let uploadText = null;
let f_speechSynthesizerTimestamp = null;
const FJTextToSpeechStore = {
    getPid: function () {
        return pid;
    },

    setPid: function (id) {
        pid = id;
    },

    getUploadText: function () {
        return uploadText;
    },

    setUploadText: function (text) {
        uploadText = text;
    },

    /**
     * @description 批量合成语音(微软合成)
     * @param list
     * @param options
     * @returns {Promise<void>}
     */
    batchSynthesis: async function (list, options = {}) {
        const { timestamp } = options;
        f_speechSynthesizerTimestamp = timestamp;
        //创建批量合成任务

        try {
            const createData = await FJNetworkStore.createBatchSynthesis(list);

            FJUtil.updateAllCreditInfo(true);

            // if (this._isInterrupt(timestamp)) return;

            const createId = createData?.id;
            const data = await this._getBatchSynthesis(createId);

            //获取任务结果
            if (!data) return;
            const blobDataUrl = data.outputs.result;

            //获取文件
            const blobData = await FJNetworkStore.urlToBlob(blobDataUrl);
            FJNetworkStore.deleteBatchSynthesis(createId);
            if (!blobData) return;

            const result = await this._getDataFromZip(blobData);
            if (!result) return;
            return result;
        } catch (e) {
            return null;
        }
    },

    _getBatchSynthesis(createId) {
        return new Promise(res => {
            FJNetworkStore.getBatchSynthesis(createId, res, () => {
                res();
            });
        });
    },

    _isInterrupt(timestamp) {
        return timestamp !== f_speechSynthesizerTimestamp;
    },

    interrupt() {
        f_speechSynthesizerTimestamp = null;
    },

    _getDataFromZip(data) {
        return new Promise((res, rej) => {
            FJFileHandleUtil.getDataFromZip(data, res, rej);
        });
    },

    /**
     * @description 创建文字生成语音的任务
     * @param speechList
     * @returns {Promise<*[]>}
     */
    async createTextToAudio(speechList) {
        let eventIdList = [];
        for (let i = 0; i < speechList.length; i++) {
            const item = speechList[i];
            try {
                const { audioUrl, audioText } = FJTextToSpeechUtil.getUploadAudioInfo(item);

                let tempText = item.text;

                if (!FJStringUtil.containsArabic(tempText) && FJStringUtil.containsNumberOrMathSymbols(tempText)) {
                    const promptResult = await FJNetworkStore.getChatData({ stream: 0, type: 9, prompt: tempText });
                    if (promptResult) {
                        tempText = JSON.parse(promptResult).text;
                    }
                }

                const result = await FJNetworkStore.textToAudio({
                    text: tempText,
                    audioUrl,
                    audioText,
                });
                if (result.code === 200) {
                    eventIdList.push({ eventId: result.data.event_id, speechId: item.id });
                    FJUtil.updateAllCreditInfo(true);
                } else {
                    FJUtil.updateAllCreditInfo(true);
                }
            } catch (e) {
                console.log(e);
                FJUtil.updateAllCreditInfo(true);
            }
        }
        return eventIdList;
    },
};

export default FJTextToSpeechStore;
